module.exports = __webpack_public_path__ + "img/icon19.8862660b.png";